module.exports = __webpack_public_path__ + "img/search-input.480ead04.png";